/**
 * @param current Текущая страница
 * @param total Всего страниц
 * @param size Размер пагинации
 * @returns {[number,number]}
 */
export default function generatePagesRange(current, total, size = 3) {
  let start = current - Math.floor(size / 2);

  if (start < 1) {
    start = 1;
  }

  let end = start + size - 1; // отнимаем единицу, потому что складываем порядковое и количественное число

  if (end > total) {
    end = total;

    if (end - size > 0) {
      start = end - size + 1; // прибавляем единицу, потому что отнимаем порядковое и количественное число
    }
  }

  return [start, end];
}